import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Data } from "@angular/router";
import { ContentType } from "../shared/contentTypes";
import { MenuSettingsDataModel2, MenuSettingsDMKey } from "../shared/models";
import { ObjectObserverFactory } from "../services/objectObserverFactory";
import { CircularInjectionHelper } from "../services/circularInjectionHelper";
import { IObjectObserver } from "../services/IObjectObserver";

@Injectable({
  providedIn: "root"
})
export class MenuSettingLocationResolver implements Resolve<Data> {

  private _menuSettingObsServ: IObjectObserver<MenuSettingsDataModel2>;

  constructor(private objObsInjectHelper: CircularInjectionHelper) {
    this._menuSettingObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<MenuSettingsDataModel2>(ContentType.MenuSettings, objObsInjectHelper);
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Data> {
    const me = this;
    return new Promise<Data>((resolve, reject) => {
      me._menuSettingObsServ.GetObject(MenuSettingsDMKey)
        .then(menusetting => {
          const data: Data = {};
          data["menuSettingLocationIds"] = menusetting.locations;
          data["sortType"] = menusetting.sort_type;
          resolve(data);
        })
        .catch(e => {
          me.objObsInjectHelper.coreLogService.error("LocationFilterResolver.resolve", "_menuSettingObsServ.GetObject", e);
          reject();
        });
    });
  }
}
